import userManager from "@/services/userManager";

// Agent Platform web SDK (floating capture button) is an internal tool, enabled for this user only.
const ENABLED_EMAIL = "thanhtung9630@gmail.com";

// Key the SDK reads to decide whether its floating button may boot (see SDK autoInit).
const SDK_UNLOCK_KEY = "ap-sdk-fab-unlocked";

let loaded = false;

export function isAgentPlatformSdkEnabled(): boolean {
  const email = userManager.getUserInfo()?.email;
  return typeof email === "string" && email.trim().toLowerCase() === ENABLED_EMAIL;
}

// Loads the SDK lazily (so other users never download it) and boots it via autoInit():
// a saved connection (sessionStorage) is restored silently on reload; otherwise only the
// floating button is shown and the connect panel opens when it is clicked. The backend URL /
// token come from the SDK's own sign-in popup, nothing is hardcoded.
export async function setupAgentPlatformSdk(): Promise<void> {
  if (loaded || !isAgentPlatformSdkEnabled()) {
    return;
  }
  loaded = true;
  try {
    const sdk = await import("@tung-engineering/agent-platform-web-sdk");
    try {
      localStorage.setItem(SDK_UNLOCK_KEY, "1");
    } catch (e) {
      // storage unavailable: SDK falls back to its URL-hash unlock, nothing else to do
    }
    sdk.autoInit();
  } catch (e) {
    loaded = false;
    console.warn("Agent Platform SDK failed to load", e);
  }
}

export async function teardownAgentPlatformSdk(): Promise<void> {
  if (!loaded) {
    return;
  }
  loaded = false;
  const sdk = await import("@tung-engineering/agent-platform-web-sdk");
  sdk.destroy();
}
